import React, { createContext, useContext, useState, useEffect } from "react";

const BookingContext = createContext();
export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const initialBookings = (() => {
    try {
      const v = localStorage.getItem("bookings");
      return v ? JSON.parse(v) : [];
    } catch {
      return [];
    }
  })();

  const storedPickupService =
    localStorage.getItem("pickupService") || "in-store";
  const storedAddress = localStorage.getItem("deliveryAddress") || "";

  const [bookings, setBookings] = useState(initialBookings);
  const [pickupService, setPickupService] = useState(storedPickupService);
  const [address, setAddress] = useState(storedAddress);
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    localStorage.setItem("bookings", JSON.stringify(bookings));
  }, [bookings]);

  useEffect(() => {
    localStorage.setItem("pickupService", pickupService);
  }, [pickupService]);

  useEffect(() => {
    localStorage.setItem("deliveryAddress", address);
  }, [address]);

  const addBooking = (newBooking) => {
    setBookings((prev) => [...prev, newBooking]);
  };

  return (
    <BookingContext.Provider
      value={{
        bookings,
        setBookings,
        pickupService,
        setPickupService,
        address,
        setAddress,
        customer,
        setCustomer,
        addBooking,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};
